import type { SVGProps } from "react";

export function LungsIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <path d="M12 3v7" />
      <path d="M12 10c-2.5 0-4.5 1.5-5.5 4s-1 5.5 1 7.5 5 1.5 6.5-1c.5-1 .5-2.5.5-4.5V10c0-2-1-3.5-2.5-3.5z" />
      <path d="M12 10c2.5 0 4.5 1.5 5.5 4s1 5.5-1 7.5-5 1.5-6.5-1c-.5-1-.5-2.5-.5-4.5V10c0-2 1-3.5 2.5-3.5z" />
    </svg>
  );
}
